import { api } from '@/shared/api/client';
import type { ApiResponse } from '@/shared/types/api';
import type { RecentActivityData } from '../types';

// Dashboard Overview Types
export interface DashboardStats {
  totalProperties: number;
  totalBeds: number;
  bedUtilization: string;
  monthlyIncome: number;
}

export interface DashboardHouse {
  id: string;
  name: string;
  images: string[];
  status: string;
  capacityPercentage: string;
  capacity: number;
  totalResident: number;
}

export interface DashboardOverviewResponse {
  stats: DashboardStats;
  houses: DashboardHouse[];
}

// Dashboard API
export const dashboardApi = {
  // Get dashboard overview
  getOverview: async (): Promise<DashboardOverviewResponse> => {
    const response = await api.get<ApiResponse<DashboardOverviewResponse>>(
      '/houses/dashboard/overview',
    );
    return response.data;
  },

  // Get recent activity
  getRecentActivity: async (): Promise<RecentActivityData> => {
    const response = await api.get<ApiResponse<RecentActivityData>>(
      '/dashboard/recent-activity',
    );
    return response.data;
  },
};
